import { jsx as _jsx } from "react/jsx-runtime";
import { ComputerSpinner } from '#pplx/frontend/apps/ask/computer/branding/ComputerSpinner.js';
import React, { useEffect, useRef, useState } from 'react';
export const COMPUTER_HAPPY_EVENT = 'computer-spinner:happy';
const HAPPY_DURATION_MS = 1000;
export const ComputerHomeSpinner = React.memo(function ComputerHomeSpinner({ size = 33 }) {
    const [spinnerState, setSpinnerState] = useState('listening');
    const timeoutRef = useRef(undefined);
    useEffect(() => {
        const handleHappy = () => {
            setSpinnerState('happy');
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => setSpinnerState('listening'), HAPPY_DURATION_MS);
        };
        document.addEventListener(COMPUTER_HAPPY_EVENT, handleHappy);
        return () => {
            document.removeEventListener(COMPUTER_HAPPY_EVENT, handleHappy);
            clearTimeout(timeoutRef.current);
        };
    }, []);
    return _jsx(ComputerSpinner, { size: size, state: spinnerState });
});
//# sourceMappingURL=ComputerHomeSpinner.js.map